import React, { useState, useEffect } from 'react';
import styled from 'styled-components';


const SwitchMini = ({ active, onClick }) => {

    const [switchOn, setSwitchOn] = useState(!active ? false : active);

    useEffect(() => {
        setSwitchOn(active);
    }, [active])

    return (

        <Container onClick={() => {
            setSwitchOn(current => !current)
            onClick()
        }} on={switchOn ? 'ON' : 'OFF'}>
            <Circle on={switchOn ? 'ON' : 'OFF'} />
        </Container>

    )

}

export default SwitchMini;



const Container = styled.div`
    width:30px;
    height:18px;
    background:${props => props.on === 'ON' ? '#00cd70' : 'rgb(236, 120, 125)'};
    border-radius:100px;
    border:1px solid #f5f5f5;
    position:relative;
    transition: all 0.4s;
    cursor:pointer;
    display:flex;
    justify-content:center;
    align-items:center;
`

const Circle = styled.div`
    width:20px;
    height:20px;
    position:absolute;
    top:-2px;
    left:-8px;
    border-radius:100px;
    background:#ffffff;
    box-shadow: rgba(60, 66, 87, 0.16) 0px 0px 10px 0px, rgba(0, 0, 0, 0.16) 0px 0px 10px 0px;
    transition: all 0.4s;
    transform: translateX(${props => props.on === 'ON' ? '23px' : '0px'});
`